export default "__VITE_ASSET__kvNuCqn___"